import { render, staticRenderFns } from "./ModalChangeOrders.vue?vue&type=template&id=6a4ec29a&lang=pug&"
import script from "./ModalChangeOrders.vue?vue&type=script&lang=js&"
export * from "./ModalChangeOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports